import {type FC, useMemo} from 'react';

import type {ChannelCourseResource} from '../../../../../../api/channel';
import type {Nullable} from '../../../../../../utils/utility-types';
import type {Channel} from '../../../../types';

import {isCourseCorporate} from '../../../../../../utils/entity/course';
import {getFileSrc} from '../../../../../../utils/entity/file';
import {ProgramChannelsListItemJSX} from '../../../../components/ChannelsListItem/ProgramChannelsListItem';
import {ChannelInfoStore} from '../../../../stores/ChannelInfo';

type Props = {
  channel: Channel;
  isDisabled?: boolean;
};

export const ProgramChannelsListItem: FC<Props> = ({channel, isDisabled}) => {
  const store = useMemo(
    () => new ChannelInfoStore({channel, channelId: channel._id}),
    [channel],
  );

  const avatarUrl = getFileSrc(store.avatar, 250).url ?? undefined;

  let title = store.title;

  const avatarTitle = store.title;

  const subtitles: string[] = [];

  const course = store.channel?.resource as Nullable<ChannelCourseResource>;

  const program = course?.program;

  if (!program) {
    title = 'Program not found';
  } else {
    const programTitle = program.title;

    if (store.userIsCoach) {
      if (store.isIndividual) {
        title = store.clientName;
        subtitles.push(store.description);
      } else {
        title = store.description;
      }
    } else {
      title = store.description;
    }

    if (isCourseCorporate(course)) {
      if (store.userIsCoach) {
        const subtenantTitle =
          course.client?.subtenant?.title || 'Subtenant not found';

        subtitles.push(subtenantTitle);
      } else {
        const coachName = course.expandedCoaches[0]?.name ?? 'Coach not found';

        subtitles.push(coachName);
      }
    } else {
      subtitles.push(programTitle);
    }
  }

  return (
    <ProgramChannelsListItemJSX
      avatarTitle={avatarTitle}
      avatarUrl={avatarUrl}
      isDisabled={isDisabled}
      subtitles={subtitles}
      title={title}
    />
  );
};
